import Modal from "react-bootstrap/Modal";
import styles from "./LimitOrDeleteModal.module.css";
import { useTranslation } from "react-i18next";
import { CustomButton } from "../../ReactBootstrap/CustomTabButton";
import { capitalizeFirstLetter } from "../../Utils/CommonFunction";
import { Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import TrainzaApi from "../../Helpers/Api";
import { useSelector } from "react-redux";
import { STATUS_CODE } from "../../Utils/StatusCode";
import { userLogoutClear } from "../../redux/slices/userSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Toster from "../../Common/Toster/Toster";
import Loader from "../../Common/Loader/Loader";

function RequestAccept({
  modelData,
  setModelData,
  handleAcceptRequests,
  grpList,
  setGrpList,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isAuthenticated = useSelector(
    (state) => state.user.userTokenTrainzaBrand
  );

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    modelData.show && grpList?.length === 0 && handleGetGroupList();
  }, [modelData.show]);

  const handleClose = () => {
    setModelData({ show: false, id: "" });
  };

  const data = modelData?.data;

  const handleCheckedGroup = (selectId) => {
    const newData = grpList?.map((item) =>
      item.id === selectId ? { ...item, isChecked: !item.isChecked } : item
    );
    setGrpList(newData);
  };

  const handleGetGroupList = () => {
    setIsLoading(true);
    const response = TrainzaApi.groupList(isAuthenticated, "");
    setIsLoading(true);
    response.then((response) => {
      setIsLoading(false);
      if (
        response?.data?.code === STATUS_CODE.INVALID_TOKEN ||
        response?.data?.code === STATUS_CODE.SESSION_EXPIRED
      ) {
        dispatch(userLogoutClear());
        Toster(t("SESSION_EXPIRED"), "error");
        navigate("/sign-up");
      } else {
        setGrpList(
          response?.data?.groupList?.map((item) => ({
            ...item,
            isChecked: true,
          }))
        );
      }
    });
  };

  const handleSubmit = () => {
    const isChecked = grpList?.some((item) => item?.isChecked);
    if (!isChecked) {
      Toster(t("MUST_SELECT_ONE_GRP"), "error");
    } else {
      handleAcceptRequests();
    }
  };

  return (
    <>
      <Modal show={modelData.show} onHide={() => handleClose()}>
        {isLoading && <Loader />}
        <Modal.Header closeButton style={{ background: "#F5F4F4" }}>
          <Modal.Title>
            <div className={styles.modalHead}>
              <p>
                {t("ACCEPT")} <span>{t("REQUEST")}</span>
              </p>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={styles.modalBody}>
            <div className={styles.name}>
              {capitalizeFirstLetter(data?.firstName ? data?.firstName : "")}{" "}
              {data?.lastName ? data?.lastName : ""}
            </div>

            <div className={styles.devider}></div>

            <div className={styles.trainingGrp}>
              <p>
                {t("TRAINING")} <span>{t("GROUPS_")}</span>
              </p>
            </div>

            <div className={styles.grpContainer}>
              {grpList.map((val, ind) => {
                return (
                  <div>
                    <Form.Group key={ind} className={styles.grpSection}>
                      <Form.Check
                        className="selectCheckBox checkBoxGroup"
                        type="checkbox"
                        label={""}
                        name={""}
                        checked={val?.isChecked}
                        onChange={() => {
                          handleCheckedGroup(val.id);
                        }}
                      />
                      <div
                        className={styles.grpName}
                        onClick={() => {
                          handleCheckedGroup(val.id);
                        }}
                      >
                        {val?.name}
                      </div>
                    </Form.Group>
                  </div>
                );
              })}

              {!isLoading && grpList?.length === 0 ? (
                <div className={styles.noActiveGrp}>
                  <p>
                    {t("CURRNETLY_HAVE_NO_GRP")} -{" "}
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        navigate("/groups", {
                          state: { isShowAddSection: true },
                        });
                      }}
                    >
                      {t("ADD_GRP")}
                    </span>
                  </p>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ background: "#F5F4F4" }}>
          <div className={styles.btnSection}>
            <CustomButton
              variant={"cancelBtn"}
              type="button"
              onClick={() => handleClose()}
            >
              {t("CLOSE")}
            </CustomButton>

            <CustomButton
              variant="activeButton"
              type="button"
              onClick={() => {
                handleSubmit();
              }}
            >
              <p>
                {t("ACCEPT")} <span> {t("MEMBER_MEM")}</span>
              </p>
            </CustomButton>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default RequestAccept;
